module.exports = __webpack_public_path__ + "img/psagot.935f54a9.svg";